import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { OutsideWrapper } from "./outside-wrapper";
import { ROUTES } from "../../../system/router/routes";
import { authApi } from "../../../features/auth/api/auth.api";
import { clearAuthSession } from "../../../features/auth/model/auth.storage";

import * as Styled from "./main-menu.styled";
import { ReactComponent as LDAlogo } from "../assets/lda-logo.svg";
import { ReactComponent as SupportIcon } from "../assets/supportIcoLarge.svg";
import { ReactComponent as HumanIcon } from "../assets/human.svg";
import { ReactComponent as SupportIconSmall } from "../assets/support.svg";
import { ReactComponent as LogoutIcon } from "../assets/logout.svg";
import { ReactComponent as LegacyLinkLogo } from "../assets/legacy-link-logo.svg";
import { ReactComponent as FacilityIcon } from "../assets/facility.svg";

export const MainMenu = () => {
  const navigate = useNavigate();
  const [visibleSupportDialog, setVisibleSupportDialog] = useState(false);
  const [logoutDialog, setLogoutDialog] = useState(false);

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const logOut = async () => {
    await authApi.logout();
    clearAuthSession();
    setLogoutDialog(false);
    navigate(ROUTES.SIGN_IN, { replace: true });
  };

  return (
    <Styled.Container>
      <Styled.LogoContainer>
        <Link to={"/"}>
          <LDAlogo />
        </Link>
        <LegacyLinkLogo />
        <Styled.Tag>Demo</Styled.Tag>
      </Styled.LogoContainer>
      <Styled.InnerMenuContainer>
        <Styled.MenuItems>
          <Link to={ROUTES.SEARCH}>Search</Link>
          <Link to="/">Knowledge Base</Link>
          <Link to="/">Updates</Link>
          <Link to="/">Help & Feedback</Link>
        </Styled.MenuItems>
        <Styled.DropdownWrapper>
          <FacilityIcon />
          <OutsideWrapper setIsPopoverOpen={setIsPopoverOpen}>
            <Styled.PopoverContainer>
              <Styled.Avatar
                id="userProfileMenu"
                onClick={() => setIsPopoverOpen(!isPopoverOpen)}
              >
                NM
              </Styled.Avatar>

              {isPopoverOpen && (
                <Styled.Popover>
                  <Styled.Avatar2>NM</Styled.Avatar2>

                  <br />
                  <Styled.Name>Natalia M.</Styled.Name>
                  <br />
                  <br />
                  <Styled.MenuContainer>
                    <Styled.MenuItem2
                      onClick={() => {
                        console.log("Profile settings");
                      }}
                    >
                      <HumanIcon />
                      Profile Settings
                    </Styled.MenuItem2>
                    <Styled.MenuItem2
                      onClick={() => {
                        setVisibleSupportDialog(!visibleSupportDialog);
                      }}
                    >
                      <SupportIconSmall />
                      Support
                    </Styled.MenuItem2>
                    <Styled.MenuItem2
                      onClick={() => setLogoutDialog(!logoutDialog)}
                    >
                      <LogoutIcon />
                      Log Out
                    </Styled.MenuItem2>
                  </Styled.MenuContainer>
                </Styled.Popover>
              )}
            </Styled.PopoverContainer>
          </OutsideWrapper>
        </Styled.DropdownWrapper>
      </Styled.InnerMenuContainer>
      <Styled.ThemedDialog
        visible={visibleSupportDialog}
        style={{ width: "546px" }}
        onHide={() => {
          if (!visibleSupportDialog) return;
          setVisibleSupportDialog(!visibleSupportDialog);
        }}
      >
        <Styled.DialogWrapper>
          <SupportIcon />
          <Styled.Title>Support and feedback</Styled.Title>
          <Styled.Text>
            You may submit a question or complaint by sending an email to{" "}
            <Styled.SupportLink
              href="mailto:support@legacydataaccess.com"
              target="_blank"
            >
              support@legacydataaccess.com
            </Styled.SupportLink>
            .
            <br />
            <br />
            Thank you.
          </Styled.Text>
        </Styled.DialogWrapper>
      </Styled.ThemedDialog>
      <Styled.ThemedDialog
        visible={logoutDialog}
        style={{ width: "546px" }}
        onHide={() => {
          if (!logoutDialog) return;
          setLogoutDialog(!logoutDialog);
        }}
      >
        <Styled.DialogWrapper>
          <Styled.LogoutTitle>Want to log out?</Styled.LogoutTitle>
          <Styled.Controls>
            <Styled.CancelLogoutBtn
              onClick={() => setLogoutDialog(!logoutDialog)}
            >
              Cancel
            </Styled.CancelLogoutBtn>
            <Styled.LogOutBtn onClick={logOut}>Log Out</Styled.LogOutBtn>
          </Styled.Controls>
        </Styled.DialogWrapper>
      </Styled.ThemedDialog>
    </Styled.Container>
  );
};
